export default "__VITE_ASSET__URbjyTA1__"